/* eslint-disable no-console */

export type ConsoleType = 'info' | 'warning' | 'log' | 'error'
export type ConsoleMethod = (...args: any[]) => void

// Bound console methods
const error: ConsoleMethod = console.error.bind(console)
const info: ConsoleMethod = console.info.bind(console)
const log: ConsoleMethod = console.log.bind(console)
const warn: ConsoleMethod = console.warn.bind(console)

export function getConsoleMethod(type: ConsoleType) {
    switch (type) {
        case 'error':
            return error
        case 'info':
            return info
        case 'log':
            return log
        case 'warning':
            return warn
    }
}

export function useConsoleMethod(type: ConsoleType, ...args: any[]) {
    getConsoleMethod(type)(...args)
}

export function logAndReturn<T>(message: string, valueToLog: T): T {
    log(message)
    console.dir(valueToLog, { depth: null })
    return valueToLog
}
